var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.5 2.08389L8.15814 0.682129L0.5 8.68213L8.15814 16.6821L9.5 15.2804L3.18372 8.68213L9.5 2.08389Z","fill":"#383F49"}));
}

ArrowLeftInline.defaultProps = {"width":"10","height":"17","viewBox":"0 0 10 17","fill":"none"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
